/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendPortalInvitationRequest
 */
export interface SendPortalInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof SendPortalInvitationRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SendPortalInvitationRequest
     */
    identityDocumentType: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendPortalInvitationRequest
     */
    identityDocumentNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendPortalInvitationRequest
     */
    identityDocumentIssuingAuthority: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SendPortalInvitationRequest
     */
    identityDocumentValidUntil: Date | null;
}

/**
 * Check if a given object implements the SendPortalInvitationRequest interface.
 */
export function instanceOfSendPortalInvitationRequest(value: object): value is SendPortalInvitationRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('identityDocumentType' in value) || value['identityDocumentType'] === undefined) return false;
    if (!('identityDocumentNumber' in value) || value['identityDocumentNumber'] === undefined) return false;
    if (!('identityDocumentIssuingAuthority' in value) || value['identityDocumentIssuingAuthority'] === undefined) return false;
    if (!('identityDocumentValidUntil' in value) || value['identityDocumentValidUntil'] === undefined) return false;
    return true;
}

export function SendPortalInvitationRequestFromJSON(json: any): SendPortalInvitationRequest {
    return SendPortalInvitationRequestFromJSONTyped(json, false);
}

export function SendPortalInvitationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendPortalInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'identityDocumentType': json['identityDocumentType'],
        'identityDocumentNumber': json['identityDocumentNumber'],
        'identityDocumentIssuingAuthority': json['identityDocumentIssuingAuthority'],
        'identityDocumentValidUntil': (json['identityDocumentValidUntil'] == null ? null : new Date(json['identityDocumentValidUntil'])),
    };
}

export function SendPortalInvitationRequestToJSON(json: any): SendPortalInvitationRequest {
    return SendPortalInvitationRequestToJSONTyped(json, false);
}

export function SendPortalInvitationRequestToJSONTyped(value?: SendPortalInvitationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'identityDocumentType': value['identityDocumentType'],
        'identityDocumentNumber': value['identityDocumentNumber'],
        'identityDocumentIssuingAuthority': value['identityDocumentIssuingAuthority'],
        'identityDocumentValidUntil': value['identityDocumentValidUntil'] == null ? value['identityDocumentValidUntil'] : `${value['identityDocumentValidUntil'].getFullYear()}-${String(value['identityDocumentValidUntil'].getMonth()+1).padStart(2,'0')}-${String(value['identityDocumentValidUntil'].getDate()).padStart(2,'0')}`,
    };
}

